export const GLOBAL_MARKET_CODE = "GLOBAL";

export type MarketMode = "global" | "local";

export interface MarketPresentation {
  displayName: string;
  heroImage: string;
  flagCountryCode: string | null;
}

const DEFAULT_HERO_IMAGE = "/heros/germany_hero.png";

export const GLOBAL_MARKET_NAME_BY_LOCALE: Record<string, string> = {
  ar: "عالمي",
  bg: "Глобално",
  cs: "Globální",
  da: "Global",
  de: "International",
  el: "Παγκόσμια",
  en: "Global",
  es: "Internacional",
  fi: "Kansainvälinen",
  fr: "International",
  hi: "अंतरराष्ट्रीय",
  hr: "Međunarodno",
  hu: "Nemzetközi",
  it: "Internazionale",
  ja: "グローバル",
  ko: "글로벌",
  nl: "Internationaal",
  no: "Internasjonalt",
  pl: "Międzynarodowe",
  pt: "Internacional",
  ro: "Internațional",
  ru: "Международная",
  sk: "Medzinárodné",
  sl: "Mednarodno",
  sr: "Međunarodno",
  sv: "Internationellt",
  tr: "Uluslararası",
  uk: "Міжнародна",
  zh: "全球",
};

export const DEFAULT_GLOBAL_MARKET: MarketPresentation = {
  displayName: "Global",
  heroImage: DEFAULT_HERO_IMAGE,
  flagCountryCode: null,
};

export const MARKET_PRESENTATION_BY_COUNTRY: Record<
  string,
  MarketPresentation
> = {
  AE: {
    displayName: "الإمارات العربية المتحدة",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "ae",
  },
  AT: {
    displayName: "Österreich",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "at",
  },
  BE: {
    displayName: "België",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "be",
  },
  BG: {
    displayName: "България",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "bg",
  },
  CZ: {
    displayName: "Česko",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "cz",
  },
  DE: {
    displayName: "Deutschland",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "de",
  },
  DK: {
    displayName: "Danmark",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "dk",
  },
  ES: {
    displayName: "España",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "es",
  },
  FI: {
    displayName: "Suomi",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "fi",
  },
  FR: {
    displayName: "France",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "fr",
  },
  GB: {
    displayName: "United Kingdom",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "gb",
  },
  GR: {
    displayName: "Ελλάδα",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "gr",
  },
  HR: {
    displayName: "Hrvatska",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "hr",
  },
  HU: {
    displayName: "Magyarország",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "hu",
  },
  IT: {
    displayName: "Italia",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "it",
  },
  NL: {
    displayName: "Nederland",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "nl",
  },
  NO: {
    displayName: "Norge",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "no",
  },
  PL: {
    displayName: "Polska",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "pl",
  },
  PT: {
    displayName: "Portugal",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "pt",
  },
  QA: {
    displayName: "قطر",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "qa",
  },
  RO: {
    displayName: "România",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "ro",
  },
  RS: {
    displayName: "Srbija",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "rs",
  },
  SE: {
    displayName: "Sverige",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "se",
  },
  SI: {
    displayName: "Slovenija",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "si",
  },
  SK: {
    displayName: "Slovensko",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "sk",
  },
  TR: {
    displayName: "Türkiye",
    heroImage: DEFAULT_HERO_IMAGE,
    flagCountryCode: "tr",
  },
};

export function getGlobalMarketName(locale: string) {
  return GLOBAL_MARKET_NAME_BY_LOCALE[locale] || "Global";
}

export function getMarketPresentation(countryCode: string) {
  if (countryCode === GLOBAL_MARKET_CODE) {
    return DEFAULT_GLOBAL_MARKET;
  }

  return (
    MARKET_PRESENTATION_BY_COUNTRY[countryCode] || {
      displayName: countryCode,
      heroImage: DEFAULT_HERO_IMAGE,
      flagCountryCode: countryCode.toLowerCase(),
    }
  );
}
